// extracted by mini-css-extract-plugin
module.exports = {"uploadBtn":"add-screenshots_uploadBtn_3tv95"};